import { MindMapPlaceholder } from './toolbar/mindmap-importing-placeholder';
import { EdgelessMindmapMenu } from './toolbar/mindmap-menu';
import { EdgelessMindmapToolButton } from './toolbar/mindmap-tool-button';
import {
  EdgelessStreamLainFlowMenu,
  EdgelessStreamLainFlowToolButton,
  StreamLainFlowArt,
} from './toolbar/streamlain-flow-tool';

export function effects() {
  customElements.define(
    'edgeless-mindmap-tool-button',
    EdgelessMindmapToolButton
  );
  customElements.define('edgeless-mindmap-menu', EdgelessMindmapMenu);
  customElements.define(
    'edgeless-streamlain-flow-tool-button',
    EdgelessStreamLainFlowToolButton
  );
  customElements.define(
    'edgeless-streamlain-flow-menu',
    EdgelessStreamLainFlowMenu
  );
  customElements.define('streamlain-flow-art', StreamLainFlowArt);
  customElements.define('mindmap-import-placeholder', MindMapPlaceholder);
}

declare global {
  interface HTMLElementTagNameMap {
    'edgeless-mindmap-tool-button': EdgelessMindmapToolButton;
    'edgeless-mindmap-menu': EdgelessMindmapMenu;
    'edgeless-streamlain-flow-tool-button': EdgelessStreamLainFlowToolButton;
    'edgeless-streamlain-flow-menu': EdgelessStreamLainFlowMenu;
    'streamlain-flow-art': StreamLainFlowArt;
    'mindmap-import-placeholder': MindMapPlaceholder;
  }
}
